import { render, staticRenderFns } from "./form_v1.vue?vue&type=template&id=0b0bcc12&scoped=true"
import script from "./form_v1.vue?vue&type=script&lang=js"
export * from "./form_v1.vue?vue&type=script&lang=js"
import style0 from "./form_v1.vue?vue&type=style&index=0&id=0b0bcc12&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0bcc12",
  null
  
)

export default component.exports